import React from "react";
import axios from "../../../config/axios";
import toastr from "toastr";

const BACKSPACE=8;
const KEYDOWN=69;

class OTP extends React.Component {
    constructor (){
       super()
    }

    componentDidMount = () => {
        //console.log("3333333",this.refs.input_1.focus())
        this.refs.input_1.focus();
      }

    handleChange=(e)=>{
        let {value, name}=e.target;
        const {eventTobeDeleted} = this.props;
        value=value.toString().substr(0,1);
        let number=name.split("_")[1];
        if(number==="4")
        {
            this.refs['input_4'].blur()
            this.setState({lastInput:value})
        }
        else
        {
            this.refs[`input_${Number(number)+1}`].focus()
        }
        this.refs[`input_${Number(number)}`].value=value;
        const { input_1, input_2 ,input_3, input_4}=this.refs;
        const otp=input_1.value.toString()+input_2.value.toString()+input_3.value.toString()+input_4.value.toString();
        //api
        this.props.getOtpVal(otp)
    }

    handleKeyDown=(e)=>{
        switch(e.keyCode) {
            case BACKSPACE:
                e.preventDefault();
                this.changeFocus('',e.target);
                break;
            case KEYDOWN:
                e.preventDefault();
                break;
            default:
                break;
        }


    }

    changeFocus=(value, target)=>{
        const number=target.name.split("_")[1];
        if(number==="4")
        {
            this.setState({lastInput:""});
        }
        if(number!=="1")
        {
            if(this.refs[`input_${Number(number)}`].value !='')
            {
                this.refs[`input_${Number(number)}`].value=''
                this.refs[`input_${Number(number)-1}`].focus();
            }
            else if(this.refs[`input_${Number(number)}`].value=='')
            {
                this.refs[`input_${Number(number)-1}`].value='';
                this.refs[`input_${Number(number)-1}`].focus();
                 
            }
        }
        else
        {
            this.refs[target.name].value=value;
        }


    }
    handlePaste=(e)=>{
        let pastedText=undefined;
        if(window.clipboardData && window.clipboardData.getData)
        {
            pastedText=window.clipboardData.getData('Text').trim();
        }
        else if(e.clipboardData && e.clipboardData.getData)
        {
            pastedText=e.clipboardData.getData('text/plain').trim();
        }
        if ( pastedText && pastedText.length < 5) {
            for (let i = 0; i < pastedText.length; i++) {
              let val = pastedText.charAt(i) * 1
              let name = `input_${i + 1}`
              this.refs[name]['value'] = val
              if (i !== 2) {
                this.refs[`input_${Number(i) + 1}`].focus()
              }
            }
          }

    }
    render () {
        return <div className="otpInp">
            <input
            type="text"
            placeholder="_"
            pattern="/d*"
            maxLength={1}
            ref={'input_1'}
            name={'input_1'}
            className="inp_fld"
            onChange={
                this.handleChange
            }
            onKeyDown={this.handleKeyDown}
            onPaste={this.handlePaste}
            />
            <input
            type="text"
            placeholder="_"
            pattern="/d*"
            maxLength={1}
            ref={'input_2'}
            name={'input_2'}
            className="inp_fld"
            onChange={
                this.handleChange
            }
            onKeyDown={this.handleKeyDown}
            onPaste={this.handlePaste}
            />
            <input
            type="text"
            placeholder="_"
            pattern="/d*"
            maxLength={1}
            ref={'input_3'}
            name={'input_3'}
            className="inp_fld"
            onChange={
                this.handleChange
            }
            onKeyDown={this.handleKeyDown}
            onPaste={this.handlePaste}
            />
            <input
            type="text"
            placeholder="_"
            pattern="/d*"
            maxLength={1}
            ref={'input_4'}
            name={'input_4'}
            className="inp_fld"
            onChange={
                this.handleChange
            }
            onKeyDown={this.handleKeyDown}
            onPaste={this.handlePaste}
            />

        </div>
    }

}

export default OTP;



// WEBPACK FOOTER //
// ./src/views/ISEAS/RefundMangement/otp.js